import React from 'react';
import styled from 'styled-components';
import { Caption, DropdownSelect } from '@prezi/bento';
import { neutral300 } from '@prezi/common-design';
import { ColumnMinAutoMin, TeamAvatar, FlexColumn } from '../../atoms/dumb';
import { documentAccessOptions } from '../../__stories__';
import { createDataLookup } from '../../const';
const Meta = styled(Caption).withConfig({
  displayName: "TeamDisplay__Meta",
  componentId: "sc-1xpkrcm-0"
})(["color:", ";"], neutral300);
const TeamDisplay = () => {
  const [value, setValue] = React.useState(documentAccessOptions[0].value);
  const handler = value => setValue(value);
  return React.createElement(ColumnMinAutoMin, null, React.createElement(TeamAvatar, null), React.createElement(FlexColumn, null, React.createElement(Caption, null, "Team Name"), React.createElement(Meta, null, "100 team members")), React.createElement(DropdownSelect, {
    value: value,
    options: documentAccessOptions,
    disabled: false,
    onChange: handler,
    dataLookup: createDataLookup('team-permissions-select')
  }));
};
export default TeamDisplay;